import type { MockApplicantData } from "./candidate-pool.types";
import type { MockDbState } from "./mock-db-store";
import type { MockJobPostData } from "../types";

type AddCandidateOptions = {
  jobPostId: string;
  candidate: Partial<MockApplicantData>;
  state: MockDbState;
  additionalCandidateProps: Partial<MockApplicantData>;
};

export function addCandidateToJobHelper({
  jobPostId,
  candidate,
  state,
  additionalCandidateProps,
}: AddCandidateOptions): MockDbState {
  const applicationId = crypto.randomUUID();
  const appliedOn = candidate.appliedAt ?? new Date().toISOString();
  const savedCandidate = { ...candidate, applicationId, appliedOn };

  const jobPost = state.jobPosts.find((j) => j.jobPostId === jobPostId);

  if (!jobPost) {
    throw new Error("Invalid job id");
  }

  const newState: MockDbState = {
    ...state,
    candidates: [
      ...state.candidates,
      { ...savedCandidate, ...additionalCandidateProps },
    ] as MockApplicantData[],
    jobPosts: [
      ...(state.jobPosts.filter((j) => j.jobPostId !== jobPostId) as MockJobPostData[]),
      {
        ...jobPost,
        applicationIds: [...(jobPost.applicationIds ?? []), applicationId],
      } as MockJobPostData,
    ],
  };

  return newState;
}
